import React from "react";
import Leaflet from "../Leaflet/Leaflet";
import "./ContactUs.css";
import tool from "../../img/tools.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

const ContactUs = () => {
  return (
    <div>
      <div className="container mt-5">
        <div className="d-flex justify-content-center align-items-center about-me-title">
          <h1>Contact Address</h1>
        </div>
        <div className="d-flex flex-lg-row flex-column justify-content-around align-items-center mt-4">
          <div className="leaflet-texts">
            <h5>
              <FontAwesomeIcon className="me-2" icon={faLocationDot} />
              11th  Mosque Road-1260 , Belabo , Narsingdi , Dhaka.
            </h5>
            <h5 className="my-4">
              <FontAwesomeIcon className="me-3" icon={faEnvelope} />
              Official:
              <a className="ps-3" href="https://manufacture-hardware.web.app/">
                https://manufacture-hardware.web.app/
              </a>
            </h5>
            <h5 className="mb-lg-0 mb-5">
              <FontAwesomeIcon className="me-2" icon={faPhone} /> Helpline :
              01712345678 , 01623456789 , 01323456123
            </h5>
          </div>
          {/* <Leaflet></Leaflet> */}

          <div className="plan-card">
            <h2>Business<span>For business services</span></h2>
            <div className="etiquet-price">
              <p>254.99</p>
              <div></div>
            </div>
            <div className="benefits-list">
              <ul>
                <li><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                  <path d="M243.8 339.8C232.9 350.7 215.1 350.7 204.2 339.8L140.2 275.8C129.3 264.9 129.3 247.1 140.2 236.2C151.1 225.3 168.9 225.3 179.8 236.2L224 280.4L332.2 172.2C343.1 161.3 360.9 161.3 371.8 172.2C382.7 183.1 382.7 200.9 371.8 211.8L243.8 339.8zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"></path>
                </svg><span>Analysis</span></li>
                <li><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                  <path d="M243.8 339.8C232.9 350.7 215.1 350.7 204.2 339.8L140.2 275.8C129.3 264.9 129.3 247.1 140.2 236.2C151.1 225.3 168.9 225.3 179.8 236.2L224 280.4L332.2 172.2C343.1 161.3 360.9 161.3 371.8 172.2C382.7 183.1 382.7 200.9 371.8 211.8L243.8 339.8zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"></path>
                </svg><span>Consulting</span></li>
                <li><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                  <path d="M243.8 339.8C232.9 350.7 215.1 350.7 204.2 339.8L140.2 275.8C129.3 264.9 129.3 247.1 140.2 236.2C151.1 225.3 168.9 225.3 179.8 236.2L224 280.4L332.2 172.2C343.1 161.3 360.9 161.3 371.8 172.2C382.7 183.1 382.7 200.9 371.8 211.8L243.8 339.8zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"></path>
                </svg><span>Facilitate</span></li>
              </ul>
            </div>
            <div className="button-get-plan">
              <a href="#">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="svg-rocket">
                  <path d="M156.6 384.9L125.7 353.1C117.2 345.5 114.2 333.1 117.1 321.8C120.1 312.9 124.1 301.3 129.8 288H24C15.38 288 7.414 283.4 3.146 275.9C-1.123 268.4-1.042 259.2 3.357 251.8L55.83 163.3C68.79 141.4 92.33 127.1 117.8 127.1H200C202.4 124 204.8 120.3 207.2 116.7C289.1-4.07 411.1-8.142 483.9 5.275C495.6 7.414 504.6 16.43 506.7 28.06C520.1 100.9 516.1 222.9 395.3 304.8C391.8 307.2 387.1 309.6 384 311.1V394.2C384 419.7 370.6 443.2 348.7 456.2L260.2 508.6C252.8 513 243.6 513.1 236.1 508.9C228.6 504.6 224 496.6 224 488V380.8C209.9 385.6 197.6 389.7 188.3 392.7C177.1 396.3 164.9 393.2 156.6 384.9V384.9zM384 167.1C406.1 167.1 424 150.1 424 127.1C424 105.9 406.1 87.1 384 87.1C361.9 87.1 344 105.9 344 127.1C344 150.1 361.9 167.1 384 167.1z"></path>
                </svg>
                <span>START PROJECT</span>
              </a>
            </div>
          </div>


        </div>
      </div>
      <div>
        <div>
          <div className="d-flex justify-content-center align-items-center about-me-title mt-lg-4 mt-3">
            <h1 >Our Mission Vision</h1>
          </div>
          <div className="d-flex flex-lg-row flex-column-reverse justify-content-center align-items-center container  about-me-container mt-4">
            <div className="about-me-text-container mx-auto mt-lg-0 my-lg-0 my-5">
              <p>
                Think about the brands you purchase from over and over. Why do you choose to buy products and or services from them even when cheaper options exist?

                Well, there's a good reason for it — because of their values. The best brands combine physical, emotional, and logical elements into one exceptional customer (and employee) experience that you value as much as they do.

                When your brand creates a genuine connection with customers and employees, they'll stay loyal to your company, thereby increasing your overall profitability. But this type of success doesn’t happen overnight.
              </p>
              <p>
                As a company grows, its objectives and goals may be reached, and in turn, they'll change. Therefore, mission statements should be revised as needed to reflect the business's new culture as previous goals are met.

                But first, you have to understand how to write a proper mission statement to build off of as your company evolves.
              </p>
            </div>
            <div className=" mx-auto ">
              <img className=" img-fluid p-5 rounded" src={`https://i.ibb.co/nb0cXZ0/good-customer-service-printable-in-cure-draw-page-removebg-preview.png`} alt="teamwork" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
